import gql from 'graphql-tag';
const TARGET_PRACTICE_ACTIVITY_FRAGMENT = gql `
  fragment TargetPracticeActivityFragment on TargetPracticeActivity {
    targetKey
    rounds {
      id
      keystrokes
    }
  }
`;
export default TARGET_PRACTICE_ACTIVITY_FRAGMENT;
